<template>
    <div>
        <div v-if="reportLoading">
            <div class="row">
                <div class="col-md-12 text-center pt-5 pb-5 mt-5 pb-5">
                    <i class="fa fa-circle-notch fa-spin fa-10x fa-fw" aria-hidden="true"></i>
                </div>
            </div>
        </div>

    <div v-if="reportFound === false && reportLoading === false">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">Sorry...</h2>
            </div>
        </div>
        <div class="widget">
            <div class="widget-body">
                <p>The report could not be found. Please check the URL and try again.</p>
                <p> <router-link to="/">Return Home</router-link></p>
            </div>
        </div>
    </div>
    <div v-if="extinguisherReport">
        <div class="row pb-4">
            <div class="col-md-8">
                <h2 class="page-header-title">
                    <router-link to="/extinguisher-reports">
                        Extinguisher Reports</router-link>
                    &raquo;
                    {{ extinguisherReport.job_number }} | {{ extinguisherReport.prepared_for }}        </h2>
            </div>
            <div class="col-md-4">
                <router-link :to="{ name: 'extinguisher-report-edit', params: {id: extinguisherReport.site_extinguisher_report_id} }" class="btn btn-outline-secondary btn-square btn-lg pull-right">
                    Edit Report
                </router-link>
            </div>
        </div>

        <div class="widget">
            <div class="widget-body">
                <table class="table table-bordered">
                    <tbody>
                    <tr>
                        <td><strong>Job Number</strong></td>
                        <td>{{ extinguisherReport.job_number }}</td>
                    </tr>
                    <tr>
                        <td><strong>Prepared for</strong></td>
                        <td>{{ extinguisherReport.prepared_for }}</td>
                    </tr>
                    <tr>
                        <td><strong>Prepared by</strong></td>
                        <td>{{ extinguisherReport.prepared_by }}</td>
                    </tr>
                    <tr>
                        <td><strong>Site Address</strong></td>
                        <td>{{ extinguisherReport.site_address }}</td>
                    </tr>
                    <tr>
                        <td><strong>Tamper Tag Colour</strong></td>
                        <td>{{ extinguisherReport.tamper_tag_colour !== undefined ? extinguisherReport.tamper_tag_colour : '' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Extinguisher service in accordance with BS5306-3?</strong></td>
                        <td>{{ extinguisherReport.bs5306_3_compliant !== undefined ? extinguisherReport.bs5306_3_compliant : '' }}</td>
                    </tr>
                    <tr>
                        <td><strong>Date of Inspection</strong></td>
                        <td>{{ extinguisherReport.date_of_inspection | formatDate }}</td>
                    </tr>
                    <tr v-if="extinguisherReport.offline_engineer_signature_image == null">
                        <td><strong>Engineer Signature</strong></td>
                        <td>
                            <span v-if="extinguisherReport.engineer_signature_image == null">No signature found</span>
                            <span v-else>Report signed</span>
                        </td>
                    </tr>
                    <tr v-else>
                        <td><strong>Engineer Signature (offline)</strong></td>
                        <td>
                            <img class="img-fluid" v-bind:src="extinguisherReport.offline_engineer_signature_image.data">
                        </td>
                    </tr>
                    <tr v-if="extinguisherReport.offline_client_signature_image == null">
                        <td><strong>Client Signature</strong></td>
                        <td>
                            <span v-if="extinguisherReport.client_signature_image == null">No signature found</span>
                            <span v-else>Report signed</span>
                        </td>
                    </tr>
                    <tr v-else>
                        <td><strong>Client Signature (offline)</strong></td>
                        <td>
                            <img class="img-fluid" v-bind:src="extinguisherReport.offline_client_signature_image.data">
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Client Name</strong></td>
                        <td>{{ extinguisherReport.client_signed_by }}</td>
                    </tr>
                    <tr>
                        <td><strong>Client Signed On</strong></td>
                        <td>
                            <span v-if="extinguisherReport.client_signed_date">{{ extinguisherReport.client_signed_date | formatDate }}</span>
                        </td>
                    </tr>
                    <tr v-if="extinguisherReport.overall_notes">
                        <td><strong>Overall Notes</strong></td>
                        <td>
                            <p>{{ extinguisherReport.overall_notes }}</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="widget has-shadow">
                    <div class="widget-header bordered no-actions d-flex align-items-center">
                        <h3>Extinguishers</h3>
                    </div>
                    <div class="widget-body">
                        <div class="row pb-3">
                            <div class="col-md-12 mt-3">
                                <table class="table table-condensed table-bordered" v-if="filteredExtinguishers && filteredExtinguishers.length > 0">
                                    <extinguisher-line
                                            v-for="extinguisher in filteredExtinguishers"
                                            v-bind:key="extinguisher.site_extinguisher_report_item_id"
                                            v-bind:extinguisher="extinguisher"
                                    ></extinguisher-line>
                                </table>
                                <p class="text-center" v-else>There are no extinguishers attached to this inspection.</p>
                            </div>
                        </div>
                        <router-link :to="{ name: 'extinguisher-report-add-extinguisher', params: {id: extinguisherReport.site_extinguisher_report_id} }" class="btn btn-outline-primary btn-square pt-3 pb-3 mt-3 mb-3" style="display:block;width:100%">
                            Add Extinguisher
                        </router-link>

                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import ExtinguisherLine from '@/components/ExtinguisherLine.vue';

    export default {
        components: {ExtinguisherLine},
        data() {
            return {
                reportFound: false,
                reportLoading: true,
                extinguisherReport: null,
                extinguisherReportItems: [],
            }
        },
        methods: {
            getExtinguisherReport() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('extinguisher_reports').objectStore('extinguisher_reports');
                        var storeRequest = objectStore.get(reportId);


                        storeRequest.onsuccess = function(event) {
                            vm.extinguisherReport = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.reportFound = true;
                            }
                            vm.reportLoading = false;
                        };
                        storeRequest.onerror = function(e) {
                            vm.reportFound = false;
                            vm.reportLoading = false;
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getExtinguisherReportItems() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    vm.extinguisherReportItems = [];
                    
                    try {
                        var objectStore = db.transaction('extinguisher_report_items').objectStore('extinguisher_report_items');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.extinguisherReportItems) {
                                        vm.extinguisherReportItems.push(cursor.value);
                                    }
                                    cursor.continue();
                                }
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }

                })

            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FER') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getExtinguisherReport();
            this.getExtinguisherReportItems();
        },
        computed: {
            filteredExtinguishers() {
                var correctExtinguishers = [];
                var vm = this;
                this.extinguisherReportItems.forEach(function(entry) {
                    if (entry.site_extinguisher_report_id === vm.extinguisherReport.site_extinguisher_report_id &&
                        (entry.is_deleted === false || entry.is_deleted === undefined))
                    {
                        correctExtinguishers.push(entry);
                    }
                });
                return correctExtinguishers;
            },
        }
    }
</script>